import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#ff5722',
    secondary: '#ff9800',
    accent: '#3f51b5',
    error: '#f44336',
    warning: '#ffc107',
    info: '#03a9f4',
    success: '#4caf50'
  }
})
